module.exports = __webpack_public_path__ + "img/Al-masraf.0040cc68.jpg";